import React from 'react'
import { redirectToCore } from '@helpers'
import { Dropdown, User } from '@components/UI'
import { useAuth } from '@hooks'

const UserDropdown = () => {
  const {
    profile: { name, image, type }
  } = useAuth()

  const HeaderUser = () => {
    return <User img={image} name={name} type={type} hideName size='small' />
  }

  return (
    <>
      <Dropdown
        dark
        full
        listItemProps={{
          group: 'a2',
          style: {
            opacity: 0.9
          },
          iconProps: {
            className: 'color color-f',
            style: {
              opacity: 0.5
            }
          }
        }}
        position='right top'
        action='click'
        data={[
          {
            icon: 'home',
            value: 'Home',
            onClick: () => redirectToCore('/')
          },
          // {
          //   icon: 'gift',
          //   value: 'Referrals',
          //   onClick: () => redirectToCore(`/referrals`)
          // },
          // {
          //   icon: 'info',
          //   value: 'Terms of Service',
          //   onClick: () => redirectToCore(`/terms`)
          // },
          // {
          //   icon: 'lock',
          //   value: 'Privacy Policy',
          //   onClick: () => redirectToCore(`/policy`)
          // },
          {
            icon: 'settings',
            value: 'Settings',
            onClick: () => redirectToCore(`/profile/details`)
          }
        ]}
        onchoose={(item) => {
          item.onClick()
        }}
      >
        <HeaderUser />
      </Dropdown>
    </>
  )
}

export default UserDropdown
